import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import AddBoxIcon from '@material-ui/icons/AddBox';
import Button from "@material-ui/core/Button/Button";
import FileManagerDialog from "./FileManagerDialog";
import Card from "@material-ui/core/Card/Card";
import CardActionArea from "@material-ui/core/CardActionArea/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia/CardMedia";
import CardActions from "@material-ui/core/CardActions/CardActions";
import IconButton from "@material-ui/core/IconButton/IconButton";
import DeleteIcon from '@material-ui/icons/Delete';
import {withRouter} from "react-router";
import {withSnackbar} from "notistack";
import {connect} from "trim-redux";

class ImageGallery extends React.Component {
    classes = this.props.classes;
    state={
        FileManagerPending: false,
        images: {},
    }
    componentDidMount(){
            this.loadData()
    }
    loadData(){
        this.setState({
            images:this.props.initial
        })
    }
    toggleOperation= () => {
        this.setState({
            FileManagerPending:!this.state.FileManagerPending,
        })
    }
    setImage = async (data) => {
        let {images} = this.state;
        let tempImage = images;
            await tempImage.push({
                src: data.full,
                id: data.id
            }) ;
        if(images.length >= 9){
            await this.props.enqueueSnackbar(Translate.maxGallerySizeIs9, {
                variant: 'warning',
            });
        }
        await this.setState({
            images: tempImage
        })
        await this.galleryChanges();
        await this.toggleOperation();

    }
    async removeImage(index) {
        let { images } = this.state;
        let tempImage =[];
        images.map(row =>{
            if(row.id !== index){
                tempImage.push({
                    src: row.src,
                    id: row.id
                })
            }
            return true
        });
        await this.setState({
            images: tempImage
        });
        this.galleryChanges();
    }
    galleryChanges(){
        let {images} = this.state;
        this.props.onChange(images)
    }
    render(){
        let {FileManagerPending,images} = this.state;
        return(
            <React.Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Button
                            onClick={this.toggleOperation}
                            variant="contained"
                            color="secondary"
                            size="small"
                            style={{margin:"15px 0"}}
                            startIcon={<AddBoxIcon />}
                        >
                            {Translate.addImage}
                        </Button>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>

                {
                    images.length ? images.map((row,key) =>{
                        return(
                            <Grid   item xs={12} md={6} key={key}>
                                <Card className={this.classes.filesRoot}>
                                    <CardActionArea>
                                        <CardMedia
                                            component="img"
                                            alt="Default Product Image"
                                            image={row.src}
                                            title={Translate.ProductThumbnail}
                                        />
                                    </CardActionArea>
                                    <CardActions>

                                        <IconButton size="small" onClick={() => this.removeImage(row.id)} aria-label={Translate.removeImage}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </CardActions>
                                </Card>
                            </Grid>
                        )
                    }) : null
                }
                </Grid>

                {
                    FileManagerPending ? <FileManagerDialog selection multiInsert cancleOperation={this.toggleOperation} setImage={this.setImage}/> : null
                }
            </React.Fragment>
        )
    }
}
export default withRouter(withSnackbar(withStyles(Styles)(ImageGallery)));